import WebshareApi from "..";

export const resendActivationEmailCall = () =>
  WebshareApi.post("/activation/resend/", {});
